const getPollingStations = (state) => (state.pollingStations ? state.pollingStations : []);

const getWhitelist = (state) => state.whitelist;

const getResults = (state) => state.results;

const getDetached = (state) => state.detached;

const getPollBuilderQuestions = (state) => state.pollBuilderQuestions;

const getPollChoices = (state) => state.pollChoices;

const getPollChoicesById = (state) => (id) => state.pollChoices && state.pollChoices[id];

const getSocialData = (state) => state.socialData;

const getPollResults = (state) => state.pollResults;

// eslint-disable-next-line max-len
const getPollResultsChoiceData = (state) => (id, choiceId) => state.pollResults && state.pollResults.choices[id][choiceId];

const getSelected = (choices) => {
  let selected;
  let max = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const i in choices) {
    if (!selected || choices[i].amount > max) {
      selected = i;
      max = choices[i].amount;
    }
  }

  return selected;
};

const getPollResultsAllChoice = (state) => {
  const choices = state.pollResults && state.pollResults.choices;
  if (!choices) {
    return;
  }
  const results = {};

  Object.keys(choices).forEach((key) => {
    results[key] = getSelected(choices[key]);
  });

  // eslint-disable-next-line consistent-return
  return results;
};

const getPollResultsAllChoiceById = (state) => (id) => {
  const choices = state.pollResults && state.pollResults.choices[id];

  return getSelected(choices);
};

const getUserData = (state) => state.userData && state.userData.data;

const getTokenStatus = (state) => state.userData && state.userData.tokenStatus;

/* webpoll selectors */
const webpollConfigSelector = (state) => state.webpoll.config;

const webpollIdSelector = (state) => state.webpoll.config.poll_id;

const webpollCurrentPageIndexSelector = (state) => state.webpoll.currentPageIndex;

const webpollPagesCountSelector = (state) => state.webpoll.config.pages.length;

const webpollCurrentPageSelector = (state) => {
  const { webpoll } = state;
  return webpoll.config.pages[webpoll.currentPageIndex];
};

const webpollAnswersSelector = (state) => state.webpoll.answers;

// eslint-disable-next-line max-len
const webpollAnswerCheckedSelector = (state) => (questionId) => (state.webpoll.answers[questionId] ? state.webpoll.answers[questionId] : null);

const webpollPageAnswersSelector = (state) => {
  const page = webpollCurrentPageSelector(state);
  const answers = webpollAnswersSelector(state);

  if (!page || !page.questions) {
    return {};
  }

  return page.questions.reduce((pageAnswers, question) => {
    if (answers[question.question_id] !== undefined) {
      return {
        ...pageAnswers,
        [question.question_id]: answers[question.question_id],
      };
    }

    return pageAnswers;
  }, {});
};

const isWebpollFirstPageSelector = (state) => {
  const { webpoll } = state;
  return webpoll.currentPageIndex === 0;
};

const isWebpollLastPageSelector = (state) => {
  const { webpoll } = state;
  return (webpoll.config.pages.length - 1) === webpoll.currentPageIndex;
};

const getWebpollTokenValueSelector = (state) => state.webpoll.token.value;

const isWebpollTokenValidSelector = (state) => state.webpoll.token.isValid;

const isWebpollCompletedSelector = (state) => state.webpoll.isCompleted;

export {
  getPollingStations,
  getWhitelist,
  getResults,
  getDetached,
  getPollBuilderQuestions,
  getPollChoices,
  getPollChoicesById,
  getPollResults,
  getPollResultsAllChoice,
  getPollResultsAllChoiceById,
  getPollResultsChoiceData,
  getSocialData,
  getUserData,
  getTokenStatus,
  webpollAnswersSelector,
  webpollCurrentPageIndexSelector,
  webpollCurrentPageSelector,
  webpollConfigSelector,
  webpollAnswerCheckedSelector,
  isWebpollLastPageSelector,
  isWebpollFirstPageSelector,
  webpollPageAnswersSelector,
  getWebpollTokenValueSelector,
  isWebpollTokenValidSelector,
  webpollIdSelector,
  webpollPagesCountSelector,
  isWebpollCompletedSelector,
};
